
import { canonical } from "@utils";
export default {
	name: "AppPrivacyPolicy",
	head() {
		return {
			link: [canonical(this.$route)],
		};
	},
};
